import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : false;
  });

  const [isMenuCollapsed, setIsMenuCollapsed] = useState(() => {
    const saved = localStorage.getItem('menuCollapsed');
    return saved ? saved === 'true' : false;
  });

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  useEffect(() => {
    localStorage.setItem('menuCollapsed', isMenuCollapsed.toString());
  }, [isMenuCollapsed]);

  const toggleTheme = () => setIsDark(!isDark);
  const toggleMenu = () => setIsMenuCollapsed(!isMenuCollapsed);

  return (
    <ThemeContext.Provider value={{
      isDark,
      isMenuCollapsed,
      toggleTheme,
      toggleMenu
    }}>
      {children}
    </ThemeContext.Provider>
  );
}; 